import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--ink)] text-[var(--bg)]">
      <div className="container-wide section-pad text-center">
        <p className="font-script text-[var(--gold)] text-4xl md:text-5xl mb-4">Forever starts here</p>
        <h2 className="font-serif text-5xl md:text-7xl font-light mb-8">Start Your Forever Today</h2>
        <p className="font-body text-white/60 max-w-xl mx-auto mb-10">
          Free to begin. Forever to remember. Build your love story on the only platform that grows with your marriage.
        </p>
        <Link to="/signup" data-testid="footer-cta" className="btn-gold">
          Create Your Wedding Site
        </Link>
      </div>

      <div className="border-t border-white/10">
        <div className="container-wide px-6 md:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <Heart className="w-5 h-5 text-[var(--gold)]" />
            <div>
              <p className="font-serif text-2xl">LockedInForever<span className="text-[var(--gold)]">.com</span></p>
              <p className="text-[11px] uppercase tracking-[0.25em] text-white/40">Your Love. Your Story. Locked In Forever.</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-6 text-sm text-white/60">
            <Link to="/pricing" className="hover:text-[var(--gold)]">Pricing</Link>
            <Link to="/podcast" className="hover:text-[var(--gold)]">Podcast</Link>
            <Link to="/vendors" className="hover:text-[var(--gold)]">Vendors</Link>
            <Link to="/live" className="hover:text-[var(--gold)]">Live</Link>
            <Link to="/club" className="hover:text-[var(--gold)]">Couples Club</Link>
            <Link to="/featured" className="hover:text-[var(--gold)]">Hall of Fame</Link>
            <Link to="/for-planners" className="hover:text-[var(--gold)]">For Planners</Link>
            <Link to="/planners" className="hover:text-[var(--gold)]" data-testid="footer-find-planner">Find a Planner</Link>
            <Link to="/careers" className="hover:text-[var(--gold)]" data-testid="footer-careers">Careers – Work From Home</Link>
            <Link to="/login" className="hover:text-[var(--gold)]">Log In</Link>
            <Link to="/privacy" className="hover:text-[var(--gold)]" data-testid="footer-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-[var(--gold)]" data-testid="footer-terms">Terms</Link>
          </div>
          <p className="text-xs text-white/30">© {new Date().getFullYear()} LockedInForever</p>
        </div>
      </div>
    </footer>
  );
}
